export const locale = {
  lang: 'nl',
  data: {
    ORIGIN: {
      ADD: 'Nieuw',
      NAME: 'Naam',
      DESCRIPTION: 'Omsschrijving',
      ADMINISTRATIONS: 'Administraties',
      SEARCH: 'Zoeken',
      ORIGINS: 'Herkomsten',
      SAVE: 'Opslaan',
      NEW_ORIGIN: 'Nieuwe herkomst',
      CREATED_BY: 'Gemaakt door',
      CREATED_ON: 'Gemaakt op',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/i18n/nl.ts